/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMeasure } from './en-metric-measure';
import { EnMetricSide } from './en-metric-side';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateSessionEventMetricDto
 */
export interface CreateSessionEventMetricDto {

    /**
     * Anatomical district (body segment) of the measurement.
     *
     * @type {EnMetricDistrict}
     * @memberof CreateSessionEventMetricDto
     */
    district: EnMetricDistrict;

    /**
     * Body side.
     *
     * @type {EnMetricSide}
     * @memberof CreateSessionEventMetricDto
     */
    side: EnMetricSide;

    /**
     * @type {EnMetricMeasure}
     * @memberof CreateSessionEventMetricDto
     */
    measure: EnMetricMeasure;

    /**
     * @type {string}
     * @memberof CreateSessionEventMetricDto
     */
    value: string;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateSessionEventMetricDto
     */
    eventExercise?: JoinEntityDto;
}
